import React, { createContext, useContext, useState, useMemo } from "react";

const CommonContext = createContext();

export const useCommon = () => {
  const context = useContext(CommonContext);
  if (!context) {
    throw new Error("useCommon must be used within a CommonProvider");
  }
  return context;
};

export const CommonProvider = ({ children }) => {
  // 3 variables
  const [pageTitle, setPageTitle] = useState();
  const [pageButtons, setPageButtons] = useState();
  const [menus, setMenus] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  const permissionMap = useMemo(() => {
    const map = {};

    const flattenMenu = (items) => {
      items.forEach((item) => {
        if (item.key && item.permissions) {
          map[item.key] = item.permissions;
        }
        if (item.children) flattenMenu(item.children);
      });
    };

    flattenMenu(menus);
    return map;
  }, [menus]);

  const value = {
    // Variables
    pageTitle,
    setPageTitle,
    pageButtons,
    setPageButtons,
    menus,
    setMenus,
    permissionMap,
    permissionsLoading,
    setPermissionsLoading,
  };

  return (
    <CommonContext.Provider value={value}>{children}</CommonContext.Provider>
  );
};
